import React, { Component } from 'react'
import Measure from 'react-measure'

require(`../assets/${process.env.PAGE}/css/components/camera.css`);

import { ProgressBar } from 'react-bootstrap';

const CAPTURE_OPTIONS = {
    audio: false,
    video: {
      facingMode: 'user',
    }
};

class SelfieWithDocument extends Component {
  constructor(props){
    super(props);
    this.state = {
        stream: null,
        picture: null,
        changedType: true,
        currentSecond: 0,
        countDown: null,
        shutted: false,
        checked: false,
        pictureUrl: null,
        saved: false,
        playing: false,
        hasCameraPermission: false,
        mediaSize:{
          height:0,
          width:0,
          aspectRatio: 1.586,
        },
        resizedVideo: {
          height: null,
          width: null,
        }
    }
    this.video = null;
    this.containerVideo = null;
    this.canvas = null;
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleCanPlay = this.handleCanPlay.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.onCapture = this.onCapture.bind(this);
    this.handleCapture = this.handleCapture.bind(this);
    this.onClear = this.onClear.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.manageTimer = this.manageTimer.bind(this);
  }

  componentDidMount(){
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const captureOptions = this.props.captureOptions || {
      ...CAPTURE_OPTIONS,
      video: vw > 992 ? {
        facingMode: 'user',
        width: { ideal: 4096 },
        height: { ideal: 2160 }
      } : { facingMode: 'user' }
    };
    navigator.mediaDevices
    .getUserMedia(captureOptions)
    .then(stream => {
        this.setState({
          ...this.state,
          stream: stream,
          hasCameraPermission: true,
        })
    });
  }

  componentWillUnmount(){
    this.state.stream.getTracks().forEach(track => {
        track.stop();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasCameraPermission } = this.state;
    const { fileType, play, interval } = this.props;
    const prevFileType = prevProps.fileType;
    if ((hasCameraPermission &&
         play &&
         play !== prevProps.play) ||
         play &&
         fileType &&
         prevFileType &&
         fileType.type !== prevFileType.type){

      clearInterval(this.timer);
      this.setState({
        ...this.state,
        currentSecond: 0,
        shutted: false,
        checked: false,
      });

      this.timer = setInterval(this.manageTimer, 1000);
    }
  }

  handleOnChange(event){
    event.preventDefault()
    if(this.props.onChange){
      this.props.onChange(this.state.picture);
    }
    this.setState({
      ...this.state,
      saved: true
    })
  }

  handleCapture(event) {
    const { mediaSize } = this.state;
    const offset = this.calculateOffset(mediaSize, this.video);
    if(event){
      event.preventDefault()
    }


    let hiddenCanvas = document.createElement('canvas');
    this.canvas = hiddenCanvas;
    hiddenCanvas.height = this.video.videoHeight;
    hiddenCanvas.width = this.video.videoWidth;
    let hiddenContext = hiddenCanvas.getContext('2d');
    hiddenContext.drawImage(this.video,
                            0,
                            0,
                            this.video.videoWidth,
                            this.video.videoHeight,
                            0,
                            0,
                            this.video.videoWidth,
                            this.video.videoHeight);

    hiddenCanvas.toBlob(blob => this.onCapture(blob), "image/jpeg", 1);

    this.setState({
      ...this.state,
      pictureUrl: hiddenCanvas.toDataURL('image/jpeg',1),
      shutted: true,
    });

  }

  handleResize(contentRect){
    const { mediaSize, stream } = this.state;

    let calculatedSize = {};

    if(contentRect.entry){

      if(this.video){
        let browserVideoSize = stream.getVideoTracks()[0].getSettings()
        let videoAspectRatio = null;
        let resizedVideo = {};
        let originalVideoSize = {
          width: browserVideoSize.width,
          height: browserVideoSize.height
        }

        if(contentRect.entry.height > contentRect.entry.width){
          originalVideoSize = {
            width: (browserVideoSize.width > browserVideoSize.height) ? browserVideoSize.height : browserVideoSize.width,
            height: (browserVideoSize.width > browserVideoSize.height) ? browserVideoSize.width : browserVideoSize.height,
          }
        }


        videoAspectRatio = originalVideoSize.width / originalVideoSize.height ;

        const capturedScreenHeight = originalVideoSize.height * 100 / contentRect.entry.height;
        const capturdScreenWidth = originalVideoSize.width * 100 / contentRect.entry.width;

        if( capturedScreenHeight > capturdScreenWidth){
          resizedVideo = {
            width: contentRect.entry.width,
            height: contentRect.entry.width / videoAspectRatio,
          }
        }else {
          resizedVideo = {
            width: contentRect.entry.height * videoAspectRatio,
            height: contentRect.entry.height,
          }
        }

        this.setState({
          ...this.state,
          resizedVideo: {
            ...resizedVideo,
          }
        });
      }
    }
  }

  onCapture(blob) {
    this.setState({
      ...this.state,
      picture: blob
    });
  }

  handleClear() {
    const context = this.canvas.getContext("2d");
    context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.onClear();
  }

  onClear(blob) {
    this.setState({...this.state, picture: undefined});
  }


  handleCanPlay() {
    const { mediaSize } = this.state
    const newAspectRatio = this.calculateRatio(this.video.videoHeight, this.video.videoWidth);

    this.setState({
      ...this.state,
      playing: true,
      mediaSize:{
        ...mediaSize,
        aspectRatio: (newAspectRatio || mediaSize.aspectRatio)
      }
    })
    this.video.play();
  }

  calculateRatio(height, width){
    if (height && width) {
      const isLandscape = height <= width;
      const ratio = isLandscape ? width / height : height / width;
      return ratio;
    }
  }

  calculateDocumentFrame(containerWidth, containerHeight, frameAspectRatio, defaultFixedSide=null){
    let fixedSide = (containerWidth >= containerHeight) ? containerWidth : containerHeight;
    if(defaultFixedSide){
      fixedSide = (defaultFixedSide === 'width') ? containerWidth : containerHeight
    }
    const variableSide = (fixedSide == containerWidth) ? containerHeight : containerWidth;
    const fixedSideFrame = 20;
    const fixedContentSize = Math.round(fixedSide - (fixedSideFrame * 2));
    const variableContentSize = Math.round(fixedContentSize / frameAspectRatio);
    const variableSideFrame = ((variableSide - variableContentSize) / 2);
    return {
      frameWidth: (fixedSide === containerWidth) ? fixedSideFrame : variableSideFrame,
      frameHeight:(fixedSide === containerHeight) ? fixedSideFrame : variableSideFrame,
    }
  }

  calculateOffset(videoContainer, video){
    if (video && videoContainer){
        return {
            x: video.videoWidth > videoContainer.width ?  Math.round((video.videoWidth - videoContainer.width) / 2) : 0,
            y: video.videoHeight > videoContainer.height ?  Math.round((video.videoHeight - videoContainer.height) / 2) : 0,
        }
    }
  }

  manageTimer(){
    let { currentSecond, changedType, countDown } = this.state;

    const { interval } = this.props;
    let checked = false;

    currentSecond+=1;
    countDown = null;

    if (changedType){
      currentSecond = 0;
    }

    if(currentSecond > (interval - 6) && currentSecond < (interval - 2)){
      countDown = (interval - 2) - currentSecond;
    }

    if(currentSecond === (interval - 2)){
      this.handleCapture();
    }

    if(currentSecond === (interval - 1)){
      this.setState({
        ...this.state,
        checked: true
      })
    }

    if(currentSecond === interval + 1 ){
      if(this.props.lastType === false){
        currentSecond = 0;
      }
      this.handleChange();
    }

    this.setState({
      ...this.state,
      currentSecond: currentSecond,
      countDown: countDown,
      changedType: false,
    })

  }

  handleChange(){
    const { fileType, onChange } = this.props;
    const { picture } = this.state;

    onChange(picture);
  }

  render() {
    const { mediaSize, hasCameraPermission, resizedVideo, shutted, currentSecond, checked, countDown } = this.state;
    const { shapeStyle, fileType, play, interval } = this.props;
    if (this.state.stream && this.video && !this.video.srcObject) {
        this.video.srcObject = this.state.stream;
    }
    const selfieIcon = (
    <div
      style={{
        textAlign: "center",
        padding: '0px'
      }}>
      <img
        src={(hasCameraPermission && play && fileType && ((checked && fileType.successIcon) || fileType.icon) || '')}
        style={{
          maxWidth: "48px",
          width: "100%"
        }}/>
    </div>);

    const selfieTip = (
    <div
      style={{
        textAlign: "center",
      }}>
      <h3 style={{
        margin: "0 auto",
        color: "#FFF",
        }}>
          {hasCameraPermission && play && fileType && fileType.description || ''}
      </h3>
    </div>)

    const documentFrames = this.calculateDocumentFrame(mediaSize.width, mediaSize.height, shapeStyle.aspectRatio, shapeStyle.defaultFixedSide);
    const videoOffset = this.calculateOffset(mediaSize, this.video);

    const ConfirmButtons = (<div>
                              <button className='btn btn-primary action-button' onClick={this.handleOnChange}><span className="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
                              <button className='btn btn-primary action-button' onClick={this.handleClear}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
                            </div>);
    const shownButtons = this.state.picture ? ConfirmButtons :  (<button onClick={this.handleCapture} className='btn btn-primary btn-lg action-button'>
                                                                    <span className="glyphicon glyphicon-camera" aria-hidden="true">
                                                                    </span>
                                                                </button>);
    const alert = (
      <div className="alert alert-warning" role="alert">
        <span>
          Debes aceptar el permiso para poder acceder a tu camara.
        </span>
      </div>
    );

    const startButton = (
      <div style={{
        textAlign: "center"
      }}>
        <h4>Colocate sosteniendo tu dni en el rectángulo y pulsa el boton comenzar</h4>
        <button
          onClick={this.props.onStart}
          className='btn btn-primary btn-lg action-button'>
            Comenzar
        </button>
      </div>
    );

    return (
      <div
      style={{
        height: "100%",
        width: "100%",
        background: "#000",
      }}>
        <div style={{
          height: "100%",
          width: "100%",
          margin: "0 auto",
        }}>
            { (!hasCameraPermission && alert) ||
              (<Measure onResize={this.handleResize}>
                {({ measureRef }) => (
                  <div
                  ref={measureRef}
                  style={{
                    position:"relative",
                    height: "100%",
                    width: "100%",
                    overflow:"hidden"
                  }}>
                    <video
                      ref={(component) => { this.video = component }}
                      onPlay={this.handleCanPlay}
                      style={{
                        position: 'absolute',
                        width: (resizedVideo && resizedVideo.width || "100%"),
                        height:(resizedVideo && resizedVideo.height || "100%"),
                        objectFit: "fill",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)scaleX(-1)",
                      }}
                      hidden={false}
                      autoPlay
                      playsInline
                      muted
                    />
                    <div
                      className={ shutted ? 'shutted' : ''}
                      style={{
                        position: 'absolute',
                        width: "100%",
                        height: "100%",
                      }}>
                        <div style={{
                          position: 'absolute',
                          marginLeft: "50%",
                          top:"45%",
                          transform: "translate(-50%, -50%)",
                          width: (resizedVideo.width > resizedVideo.height) ? "120vh" : "95vw",
                          height: (resizedVideo.width > resizedVideo.height) ? "80vh" : "100vw",
                          boxShadow: '0px 0px 20px 900px rgba(0, 0, 0, 0.6)',
                          border: '1px solid #ffffff',
                          borderRadius: 10,
                          ...shapeStyle,
                        }}>
                        </div>
                    </div>
                    <div style={{
                          position: 'absolute',
                          marginLeft: "50%",
                          top:"45%",
                          transform: "translate(-50%, -50%)",
                          fontSize: '10vh',
                          color: '#fff'
                    }}>
                      {countDown || ''}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        marginLeft: "50%",
                        transform: "translateX(-50%)",
                        top: "10px",
                        textAlign:"center",
                      }}>
                      {hasCameraPermission && play && fileType && selfieIcon}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        marginLeft: "50%",
                        transform: "translateX(-50%)",
                        bottom: "10px",
                        textAlign:"center",
                      }}>
                      {hasCameraPermission && play && fileType && selfieTip}
                      { hasCameraPermission &&
                        play &&
                        fileType &&
                        fileType.description &&
                        (<ProgressBar
                            className={`${checked ? 'progress-success' : ''}`}
                            style={{width: "60vw"}}
                            now={(currentSecond/(interval-2)) * 100}
                        />)
                      }
                      { hasCameraPermission && !play && startButton }
                    </div>
                    <canvas
                        ref={(component) => {this.canvas = component}}
                        style={{
                          position: 'absolute',
                          marginLeft: "50%",
                          transform: "translateX(-50%)",
                        }}
                        width= {this.state.mediaSize.width}
                        height= {this.state.mediaSize.height}
                        hidden= {true}
                    />
                  </div>
              )
            }
            </Measure>)
            }
        </div>
      </div>
    );
  }
}
module.exports = SelfieWithDocument;


/** WEBPACK FOOTER **
 ** ./src/components/SelfieWithDocumentSelfieCamera.js
 **/